export const IS_PROD_KEY = 'IS_PROD_KEY';
